var _style, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 69.3",
    style: {
      enableBackground: "new 0 0 2000 69.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#EEEDEE;}\r\n\t.st2{fill:#1B9A68;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1022.5,17.6c-2.8-9.9-12-17.2-22.9-17.2s-20,7.2-22.9,17.2c-1.1,4-4.7,6.6-8.8,6.6h-27.2v45.1h118.6V24.2h-28 C1027.2,24.2,1023.6,21.5,1022.5,17.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1031.8,24.3c-4.1,0-7.7,2.6-8.8,6.6c-2.9,10-12,17.2-22.9,17.2s-20.1-7.3-22.9-17.2c-1.1-3.9-4.7-6.6-8.8-6.6 H0v45.5h2000V24.3H1031.8L1031.8,24.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.6,8.5c0,1.8-1.5,3.2-3.3,3.2s-3.3-1.5-3.3-3.2s1.5-3.2,3.3-3.2S1013.6,6.8,1013.6,8.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1000,27.7c-4.5,0-8.2-3.8-8.2-8.4s3.7-8.4,8.2-8.4s8.2,3.8,8.2,8.4S1004.5,27.7,1000,27.7z M1000,14.3 c-2.7,0-4.9,2.2-4.9,5s2.2,5,4.9,5s4.9-2.2,4.9-5S1002.7,14.3,1000,14.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M1000,36.3c-4.5,0-8.2-3.8-8.2-8.4h3.4c0,2.8,2.2,5,4.9,5s4.9-2.2,4.9-5h3.4C1008.2,32.5,1004.5,36.3,1000,36.3L1000,36.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterNav);
export default __webpack_public_path__ + "static/media/FooterNav.7fe812a00502524c06916fd74407e450.svg";
export { ForwardRef as ReactComponent };